import { initialState, RootStateType, TranslationLabelValue, TranslationStateType } from './translation';

export const getState = (state: RootStateType): TranslationStateType => {
	return state.translation || initialState;
};

export const getLabelTranslations = (state: RootStateType, label: string): TranslationLabelValue => {
	return getState(state).map[label];
};
